<script>
  import {
    commonData,
    selectedArea,
    selectedPart,
    procedureList,
  } from '../../../../../../../../store/common';
  import { ENV } from '../../../../../../../../core/constants/env';

  const onSelectPart = item => {
    selectedPart.set(item);

    $commonData.forEach(
      areaItem =>
        areaItem.id === $selectedArea.id &&
        areaItem.body_parts.forEach(
          partItem =>
            partItem.body_part === $selectedPart.body_part &&
            procedureList.set(partItem.procedures),
        ),
    );
  };

  const onChangePosition = (type, id) => {
    if (type === 'back') {
      if (id === 'female_body' || id === 'male_body') {
        selectedArea.set(
          $commonData.filter(item => item.id === id + '_back')[0],
        );
      }
    } else if (type === 'front') {
      if (id === 'female_body_back' || id === 'male_body_back') {
        selectedArea.set(
          $commonData.filter(item => item.id === id.replace('_back', ''))[0],
        );
      }
    }
  };

  $: getClass = (param = '') =>
    $selectedArea.id === 'female_body' + param ||
    $selectedArea.id === 'male_body' + param
      ? 'uk-link-muted'
      : 'uk-text-bold';

  $: getStyle = (param = '') =>
    $selectedArea.id === 'female_body' + param ||
    $selectedArea.id === 'male_body' + param
      ? 'pointer-events: none'
      : '';
</script>

<div
  class="uk-text-center uk-placeholder uk-padding-small uk-position-relative uk-margin-remove-top"
>
  <div class="uk-height-large uk-position-relative uk-display-inline-block">
    <img
      class="uk-height-1-1"
      data-src={`${ENV.FRONT_URL}${$selectedArea.icon}`}
      data-uk-img
      alt={$selectedArea.name}
    />
    {#if $selectedArea?.body_parts?.length}
      {#each $selectedArea.body_parts as item}
        <a
          class="uk-position-absolute uk-transform-center {$selectedPart.id ===
            item.id && 'is-active'}"
          style={item.location}
          data-uk-marker
          data-uk-tooltip={item.body_part_name}
          on:click={() => onSelectPart(item)}
        />
      {/each}
    {/if}
  </div>

  {#if ['female_body', 'male_body', 'male_body_back', 'female_body_back'].includes($selectedArea.id)}
    <a
      class="{getClass()} uk-position-bottom-left uk-padding-small uk-margin-small-left uk-margin-small-bottom uk-text-uppercase text-xsmall"
      style={getStyle()}
      on:click={() => onChangePosition('front', $selectedArea.id)}
    >
      Front
    </a>

    <a
      class="{getClass(
        '_back',
      )} uk-position-bottom-right uk-padding-small uk-margin-small-right uk-margin-small-bottom uk-text-uppercase text-xsmall "
      style={getStyle('_back')}
      on:click={() => onChangePosition('back', $selectedArea.id)}
    >
      Back
    </a>
  {/if}
</div>
